
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/exclusive-guest-pass",
      function () {
        return require("private-next-pages/exclusive-guest-pass/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/exclusive-guest-pass"])
      });
    }
  